import { render, staticRenderFns } from "./Exceptions.vue?vue&type=template&id=2d0a32b9"
import script from "./Exceptions.vue?vue&type=script&lang=js"
export * from "./Exceptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports